import { Box, Button, Typography, Modal, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  getNewSubscriptionReachageDetails,
  PaymentCreateOrder,
} from "./smbAccountReachageApi";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { payloadDateFormat } from "../../utils/commonUtils";
import { getDataRechageDetail } from "./smbAccountRechargeCustomApiHandler";
import { getMonthDifference } from "./smbAccounrReachargeDateFunction";
import CloseIcon from "@mui/icons-material/Close";
import axios from "../../utils/axios";
import { VERIFYPAYMENT } from "../../utils/api";
import { ModalHeader } from "../../common/modalHeader";

export default function DisplayAnnualRecharge({
  open,
  setOpen,
  modalData,
  cb,
}) {
  const [pagination, setPagination] = useState({ page: 1, total: 10 });
  const [subscription, setSubscription] = useState();

  useEffect(() => {
    if (open === true) {
      getDataRechageDetail(getNewSubscriptionReachageDetails, setSubscription);
    }
  }, [open]);

  const onClose = () => {
    setOpen(false);
  };

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handlePayment = async (payload, orderId) => {
    const isScriptLoaded = await loadRazorpayScript();
    if (!isScriptLoaded) {
      alert("Failed to load Razorpay SDK.");
      return;
    }

    const options = {
      ...payload,
      order_id: orderId,
      handler: async function (response) {
        console.log("Payment successful!", response);
        try {
          const verifyRes = await axios.post(VERIFYPAYMENT, {
            orderId: orderId,
            razorpayPaymentId: response.razorpay_payment_id,
            razorpaySignature: response.razorpay_signature,
          });
          setOpen(false);
          if (cb) cb();
          console.log("Verification success:", verifyRes.data);
        } catch (error) {
          console.error("Verification failed", error);
        }
      },
      theme: {
        color: "#3399cc",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  const handleSubmit = async (item) => {
    try {
      const amountInINR = Math.round(item.totalAmountWithCGST * 100);

      const payload = {
        amount: amountInINR,
        accountRecharge: item.smbPackageCode,
      };

      console.log("Payment payload:", payload);
      console.log("Original amount:", item.totalAmountWithCGST);
      console.log("Amount in INR:", amountInINR);

      const response = await PaymentCreateOrder(payload, (res) => {
        console.log("Payment response:", res);
        handlePayment(res, res?.orderId);
      });
    } catch (err) {
      console.error("Payment error:", err);
      alert("Payment failed. Please try again.");
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "95%", sm: "60%", md: "40%", lg: "33%" },

          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
        }}
      >
        <ModalHeader
          title={"Recommended Recharge Plans for you"}
          onClose={onClose}
        />
        <Grid
          container
          spacing={2}
          sx={{ paddingX: "20px", paddingBottom: "20px" }}
        >
          <Grid item xs={12} sx={{ height: "60vh", overflowY: "auto" }}>
            <Grid container>
              {subscription?.map((item, index) => (
                <Grid
                  item
                  xs={12}
                  key={index}
                  sx={{
                    p: "10px",
                    mt: "20px",
                    borderRadius: "5px",
                    textAlign: "center",
                    backgroundColor: "#EEEEFF",
                    boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.25)",
                  }}
                >
                  <Box
                    sx={{
                      width: "auto",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
                      sx={{
                        color: (theme) => theme.palette.primary.main,
                        fontWeight: "600",
                      }}
                    >
                      {item?.smbPackage}
                    </Typography>
                    <Typography
                      sx={{
                        color: "red",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },

                        fontWeight: "500",
                      }}
                    >
                      SAVE {item?.discount} %
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "60%",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        width: "60%",
                        fontWeight: 500,
                        color: "primary.main",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      Amount (<CurrencyRupeeIcon fontSize="10px" />)
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        color: "#000",
                        fontWeight: 500,
                        textAlign: "left",
                        flexGrow: 1,
                      }}
                    >
                      : {parseFloat(item?.totalAmountWithCGST).toFixed(2)}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "60%",
                    }}
                  >
                    <Typography
                      sx={{
                        width: "60%",
                        fontWeight: 500,
                        color: "primary.main",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      Validity{" "}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#000",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        fontWeight: 500,
                        textAlign: "left",
                        flexGrow: 1,
                      }}
                    >
                      : {item?.validity} Month
                    </Typography>
                  </Box>
                  <Button
                    onClick={() => handleSubmit(item)} // Pass the item to handleSubmit
                    variant="contained"
                    sx={{
                      width: {sm:"40%", xs:"60%", md:"50%"},
                      float: "right",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      mt: "20px",
                      fontWeight: 600,
                    }}
                  >
                    Recharge Now
                  </Button>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
